import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import { rem } from 'polished'
import styled, { keyframes } from 'styled-components'
import eases from 'styles/tools/eases'

const LeftAnimation = keyframes`
  from {
    transform: translate(var(--loyalty-takeover-logo-center-x, -50%), -50%) scale(1);
  }

  to {
    transform: translate(var(--loyalty-takeover-logo-center-x, -50%), -35%) scale(0.8);
  }
`

const RightAnimation = keyframes`
  from {
    transform: translate(var(--loyalty-takeover-logo-center-x, -50%), -50%) scale(1);
  }

  to {
    transform: translate(var(--loyalty-takeover-logo-end-x, -20%), -70%) scale(0.8);
  }
`

const LogoContainer = styled.div`
  position: relative;
  --loyalty-takeover-logo-center-x: -50%;
  --loyalty-takeover-logo-end-x: -20%;

  &.small {
    height: ${rem(28)};
    width: ${rem(34)};
  }

  &.medium {
    height: ${rem(80)};
    width: ${rem(100)};
  }

  > * {
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(var(--loyalty-takeover-logo-center-x), -50%) scale(1);
    animation-fill-mode: both;
    animation-duration: 0.5s;
    animation-timing-function: ${eases.iosBounce.out};
    animation-delay: 0.5s;
  }

  [dir="rtl"] & {
    --loyalty-takeover-logo-center-x: 50%;
    --loyalty-takeover-logo-end-x: 20%;
  }

  > :nth-child(1){
    animation-name: ${LeftAnimation};
  }

  > :nth-child(2){
    animation-name: ${RightAnimation};
  }
`

interface Props {
  size: 'small' | 'medium'
}

function DoublePointTakeoverLogo(props: Props) {
  const { size } = props

  const [tier, , nextTier] = useCurrentLoyaltyTier()
  return <LogoContainer className={size}>
    <LoyaltyTierIcon size={size === 'small' ? 32 : 55} tier={tier} />
    <LoyaltyTierIcon size={size === 'small' ? 32 : 55} tier={nextTier ?? tier} />
  </LogoContainer>
}

export default DoublePointTakeoverLogo
